var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "19px",
    viewBox: "0 0 16 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "App---Signup-/-Login-(WIP)",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ONB-/-Vertical_ES-Copy",
    transform: "translate(-93, -660)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "button-copy",
    transform: "translate(20, 645)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uDBC2\\uDCFA",
    transform: "translate(73.8359, 15.2031)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.97776655,2.87417888 C10.5325922,2.20111167 10.9236988,1.28246589 10.9236988,0.354724608 C10.9236988,0.227387569 10.9146033,0.100050531 10.8964123,0 C9.98686205,0.0363820111 8.89540172,0.600303183 8.24962102,1.36432542 C7.73117736,1.94643759 7.25821122,2.87417888 7.25821122,3.80192016 C7.25821122,3.94744821 7.28549773,4.08388075 7.29459323,4.12935826 C7.34916625,4.13845376 7.44012127,4.15664477 7.5401718,4.15664477 C8.34967155,4.15664477 9.36836786,3.6109146 9.97776655,2.87417888 Z M10.6144517,4.34765033 C9.25922183,4.34765033 8.14957049,5.17534108 7.44012127,5.17534108 C6.68519454,5.17534108 5.70288024,4.40222335 4.52046488,4.40222335 C2.27387569,4.40222335 0,6.25770591 0,9.75037898 C0,11.9332996 0.836786256,14.2344618 1.88276908,15.7170288 C2.77412835,16.9722082 3.55634159,18 4.68418393,18 C5.79383527,18 6.28499242,17.2632643 7.66750884,17.2632643 C9.06821627,17.2632643 9.38655887,17.981809 10.6144517,17.981809 C11.8332491,17.981809 12.6427489,16.8630622 13.4158666,15.7625063 C14.2708439,14.4982314 14.634664,13.2703386 14.6437595,13.20667 C14.5709955,13.188479 12.2425467,12.2334512 12.2425467,9.56846892 C12.2425467,7.25821122 14.0707428,6.2213239 14.1798888,6.13946438 C12.970187,4.40222335 11.1237999,4.34765033 10.6144517,4.34765033 Z",
    id: "Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.656c1a4624a8b0bc060ea0994ddc7cc8.svg";
export { ForwardRef as ReactComponent };